import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Home } from 'lucide-react';
import { toggleFinding, normalizeFindings } from '@/utils/reportRules';

const initialOptions = [
  { id: 'opens_door', label: 'Patient öffnet selbst die Tür' },
  { id: 'in_bed', label: 'Patient liegt im Bett' },
  { id: 'on_chair', label: 'Patient sitzt auf Stuhl/Sofa' },
  { id: 'awake', label: 'Patient wach und ansprechbar' },
  { id: 'responds', label: 'Patient reagiert auf Ansprache/Schmerzreiz' }
];

export const InitialSituation = ({ data, onChange }) => {
  const handleToggle = (optionId) => {
    const newData = { ...data, selections: toggleFinding(normalizeFindings(data.selections, 'initial'), optionId, 'initial') };
    onChange(newData);
  };

  const handleFreeTextChange = (value) => {
    onChange({ ...data, freeText: value });
  };

  return (
    <Card className="section-card">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Home className="w-5 h-5 text-primary" />
          </div>
          <div>
            <CardTitle className="text-2xl">Ausgangssituation</CardTitle>
            <CardDescription className="text-base mt-1">
              Allgemeine Befunde beim Eintreffen
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {initialOptions.map((option) => (
            <div
              key={option.id}
              data-testid={`initial-${option.id.replaceAll('_', '-')}-option`}
              className={`flex items-start space-x-3 p-4 rounded-lg border-2 transition-all cursor-pointer hover:shadow-md ${
                (data.selections || []).includes(option.id)
                  ? 'option-selected'
                  : 'border-border bg-card'
              }`}
              onClick={() => handleToggle(option.id)}
            >
              <Checkbox
                id={option.id}
                data-testid={`initial-${option.id.replaceAll('_', '-')}-checkbox`}
                onClick={event => event.stopPropagation()}
                checked={(data.selections || []).includes(option.id)}
                onCheckedChange={() => handleToggle(option.id)}
                className="mt-0.5"
              />
              <Label
                htmlFor={option.id}
                onClick={event => event.stopPropagation()}
                className="text-base font-medium cursor-pointer leading-relaxed"
              >
                {option.label}
              </Label>
            </div>
          ))}
        </div>
        
        {/* Freitextfeld */}
        <div className="pt-4 border-t border-border space-y-2">
          <Label htmlFor="initial-freetext" className="text-sm font-semibold text-foreground">
            Zusätzliche Informationen zur Auffinde-Situation
          </Label>
          <Textarea
            id="initial-freetext"
            data-testid="initial-freetext"
            placeholder="z.B. Patient liegend auf dem Boden im Supermarkt, Patient in PKW sitzend nach Auffahrunfall, etc."
            value={data.freeText || ''}
            onChange={(e) => handleFreeTextChange(e.target.value)}
            className="min-h-[80px] resize-y"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default InitialSituation;
